<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" small rounded v-bind="attrs" v-on="on">From the bottom</v-btn>
    </template>
    <template v-slot:default="dialog">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col v-if="alert" cols="12" class="mt-5">
            <generalAlert
              :alert="alert"
              :alertType="alertType"
              :message="successResponse"
            />
          </v-col>
            <v-col cols="12" class="mt-5 text-center compeatfont">
                <h2 v-if="!hasPages">Get Started</h2>
                <h2 v-if="hasPages">Add To Facebook Pages List</h2>
            </v-col>
            <v-col cols="12" class="text-center">
              <p class="mb-0">
                Please select a page below. These are pages you have a role on.
              </p>
              <v-select
                v-model="page"
                :items="pages"
                item-text="name"
                item-value="account_id"
                label="Select Page"
                @change="loadDifferentPages(page)"
              >
              </v-select>
            </v-col>
            <v-col cols="12" class="text-center pt-0">
              <p class="mb-0">
                Please select the Ad Account for the page you have selected.
              </p>
              <v-select
                label="Select Your AdAccount"
                v-model="adAccountId"
                :items="adsAccountsForPage"
                item-text="name"
                item-value="id"
                @change="handleSelectedAdAccount"
              >
              </v-select>
            </v-col>
            <v-col cols="12" class="text-center">
            <v-btn text @click="dialog.value = false">Close</v-btn>
          <v-btn text v-if="hasPages == false" @click="addPagesList()">Save</v-btn>
          <v-btn text v-if="hasPages == true" @click="addToPagesList()">Save 2</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import generalAlert from "../alerts/generalAlert.vue";
import { firebaseApp } from "../../firebaseConfig";
import { setDoc, getFirestore, doc, collection, updateDoc, arrayUnion } from "firebase/firestore";
const db = getFirestore(firebaseApp);
export default {
  props: ["pages", "adsAccountsForPage", "saveUsersPages", 'hasPages', "docId"],
  data: () => ({
    page:null,
    adAccountId:"",
    fbToken: "",
    pageId: "",
    alert:false,
    alertType:'',
    successResponse:'',
    dialog:false
  }),
  components:{
    generalAlert
  },
  methods: {
    // Handels the selected ad account for insights
    handleSelectedAdAccount(value) {
      this.adsAccountId = value;
      console.log('this.adsAccountId', this.adsAccountId)
    },
    loadDifferentPages(item) {
      console.log("item", item);
      this.pages.forEach((account) => {
        if (account.name === item) {
          console.log("account", account);
          this.page = account
          this.fbToken = account.access_token;
          this.pageId = account.id;
        }
      });
    },
    async addPagesList(){
        try{
            // Generate a new document reference with a unique ID
            const newDocRef = doc(collection(db, "usersPages"));

            // Prepare the document data with the generated docId
            const data = {
                userId: this.$store.state.user.id,
                dateCreate: Date.now(),
                uid: newDocRef.id, // Add the docId to the document data
                pages: [
                    { 
                        adsAccountId: this.adsAccountId,
                        pageName: this.page.name,
                        pageToken: this.page.access_token,
                        pageId: this.page.id
                    }
                ]
            };
            // Add the new document with the specified data
            await setDoc(newDocRef, data);
            this.alert = true
            this.alertType = 'success'
            this.successResponse = "Successfull created Facebook page list."
            setTimeout(() => {
                this.page = null
                this.adAccountId = ""
                this.alert = false
                this.alertType = ''
                this.successResponse = ""
                this.$emit('reloadUsersPages', true)
                this.dialog = false
            }, 3000);

            // this.$emit('saveUsersPages', newDocRef, data)
            } catch (e) {
            // console.error("Error adding document: ", e);
            this.alert = true
            this.alertType = 'error'
            this.successResponse = "Error:" + e
            setTimeout(() => {
                this.alert = false
                this.alertType = ''
                this.successResponse = ""
            }, 3000);
            }
    },
    async  addToPagesList() {
        // The new page object to add
        const newPage = {
            adsAccountId: this.adsAccountId,
            pageName: this.page.name,
            pageToken: this.page.access_token,
            pageId: this.page.id
        };

        // Reference to the specific document you want to update
        const docRef = doc(db, "usersPages", this.docId); // Replace "documentId" with the actual document ID

        try {
            await updateDoc(docRef, {
                pages: arrayUnion(newPage)
            });
            this.alert = true
            this.alertType = 'success'
            this.successResponse = "Successfull updated Facebook page list."
            setTimeout(() => {
                this.page = null
                this.adAccountId = ""
                this.alert = false
                this.alertType = ''
                this.successResponse = ""
                this.$emit('reloadUsersPages', true)
                this.dialog = false
            }, 3000);
            console.log("Page added successfully.");
        } catch (e) {
            this.alert = true
            this.alertType = 'error'
            this.successResponse = "Error:" + e
            setTimeout(() => {
                this.alert = false
                this.alertType = ''
                this.successResponse = ""
            }, 3000);
            console.error("Error updating document: ", e);
        }
    }
  },
};
</script>
